import React, { useState } from 'react'

import {
  DirectReferralSourceOption,
  directReferralSourceOptions,
} from '@/components/modals/LogReferralModal/directReferralSourceOptions'
import { Input } from '@/components/ui/input'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { cn } from '@/lib/utils'
import {
  selectLogData,
  updateLogData,
} from '@/redux/slices/logHistoricalReferral'

const SelectDirectReferralSource: React.FC = () => {
  const logData = useAppSelector(selectLogData)
  const dispatch = useAppDispatch()
  const [otherSourceValue, setOtherSourceValue] = useState('')

  function handleSelectSource(option: DirectReferralSourceOption) {
    setOtherSourceValue('')

    if (option.label === logData.directLeadSource) {
      dispatch(updateLogData({ directLeadSource: '' }))
      return
    }

    dispatch(updateLogData({ directLeadSource: option.label }))
  }

  function handleOtherSourceChange(value: string) {
    setOtherSourceValue(value)
    dispatch(updateLogData({ directLeadSource: value }))
  }

  return (
    <section className="-mt-2">
      <div className="text-xs text-muted-foreground mb-2">Source</div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        {directReferralSourceOptions.map((option) => {
          const isSelected = option.label === logData.directLeadSource

          return (
            <button
              key={option.label}
              className={cn(
                `flex items-center gap-2 rounded-xl p-2.5 border cursor-pointer
                text-xs hover:border-primary`,
                { 'bg-primary/5 border-primary': isSelected },
              )}
              onClick={() => handleSelectSource(option)}
            >
              <div
                className={cn('text-md text-muted-foreground', {
                  'text-primary': isSelected,
                })}
              >
                {option.icon}
              </div>

              <div className="text-black">{option.label}</div>
            </button>
          )
        })}
      </div>

      <Input
        value={otherSourceValue}
        onChange={(event) => handleOtherSourceChange(event.target.value)}
        placeholder="Other source (optional)"
      />
    </section>
  )
}

export default SelectDirectReferralSource
